const history = {
  title: 'I miei progetti',
  upgradeBtn: 'Aggiornare',
  subTitle:
    'Non dimenticare di scaricare il file poiché verrà eliminato dopo 72 ore.',
  MAgo: '{{num}} minuti fa',
  HAgo: '{{num}} ore fa',
  DAgo: '{{num}} ore fa',
  justNow: 'Proprio adesso',
  originalFile: 'File originale',
  selectAllBtn: 'Seleziona tutto',
  emptyTips: 'Nessun progetto ancora. <1>Vai a modificare</1>',
  deleteTips: 'Sei sicuro di volerlo eliminare?',
};

export default history;
